module.exports = __webpack_public_path__ + "img/DAVID_CANNON_37-rs.e9c33a04.jpg";